import * as types from '../../actionTypes'

export const insertingDomainProvider = () => ({
  type: types.INSERTING_DOMAIN_PROVIDER,
})

export const insertingDomainProviderSuccess = insertDomainProviderResults => ({
  type: types.INSERTING_DOMAIN_PROVIDER_SUCCESS,
  insertDomainProviderResults,
})

export const insertingDomainProviderError = insertDomainProviderError => ({
  type: types.INSERTING_DOMAIN_PROVIDER_ERROR,
  insertDomainProviderError,
})



// WEBPACK FOOTER //
// ./src/redux/css-admin/sso-tool/actions.js